import { PUSH_RETRY_FOR_PERIOD } from '@mgCommon/constants';
import API_URLS from '@mgCommon/constants/api-urls.js';
import axiosRestInstance from '@mgCommon/http/axios-rest-client.js';
import { getCbBaseURL, getCbVarible } from '@mgCommon/utils/utils.js';

const defaultDate = new Date().toJSON().slice(0, 10);
const defaultTime = '00:00';

function restClientInstance() {
  const baseURL = getCbBaseURL();
  return axiosRestInstance({ baseURL });
}

function config(queryParams = {}) {
  const token = getCbVarible();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: queryParams,
    data: {},
  };
}

class NativePushService {
  createCampaign({
    title,
    gameId,
    androidPush,
    iosPush,
    iosPushProduction,
    iosPushSandbox,
    trigger = 3,
    broadcast = 1,
    sendType = 1,
    startDate = null,
    startDateTime = null,
    endDate = null,
    endDateTime = null,
    retryFor = 0,
    retryForPeriod = PUSH_RETRY_FOR_PERIOD.WEEKS,
    retryUntilDate = 0,
  }) {
    const data = {
      title,
      gameId,
      android_push: androidPush,
      ios_push: iosPush,
      ios_push_production: iosPushProduction,
      ios_push_sandbox: iosPushSandbox,
      trigger,
      broadcast,
      send_type: sendType,
      start_date: startDate || defaultDate,
      start_date_time: startDateTime || defaultTime,
      end_date: endDate || null,
      end_date_time: endDateTime || null,
      retry_for: retryFor || 0,
      retry_for_period: retryForPeriod,
      retry_until: retryUntilDate,
    };
    return restClientInstance().post(API_URLS.NATIVE_PUSH_CREATE_CAMPAIGN, data, config());
  }

  updateCampaign({
    title,
    campaignId,
    gameId,
    androidPush,
    iosPush,
    iosPushProduction,
    iosPushSandbox,
    trigger = 3,
    broadcast = 1,
    sendType = 1,
    startDate = null,
    startDateTime = null,
    endDate = null,
    endDateTime = null,
    retryFor = 0,
    retryForPeriod = PUSH_RETRY_FOR_PERIOD.WEEKS,
    retryUntilDate = 0,
  }) {
    const data = {
      title,
      id: campaignId,
      gameId,
      android_push: androidPush,
      ios_push: iosPush,
      ios_push_production: iosPushProduction,
      ios_push_sandbox: iosPushSandbox,
      trigger,
      broadcast,
      send_type: sendType,
      start_date: startDate || defaultDate,
      start_date_time: startDateTime || defaultTime,
      end_date: endDate || null,
      end_date_time: endDateTime || null,
      retry_for: retryFor || 0,
      retry_for_period: retryForPeriod,
      retry_until: retryUntilDate,
    };
    return restClientInstance().post(API_URLS.NATIVE_PUSH_UPDATE_CAMPAIGN, data, config());
  }

  sendNativePush({
    gameId,
    campaignId,
    playerId,
    title,
    text,
    action = null,
    url = null,
    pictureUrl = null,
    icon = null,
    nativeOs,
  } = {}) {
    const data = {
      gameId,
      campaignId,
      playerId,
      title,
      text,
      action,
      url,
      pictureUrl,
      icon,
      nativeOs,
    };
    return restClientInstance().post(API_URLS.SEND_NATIVE_PUSH, data, config());
  }
}

export default new NativePushService();
